import { handleActions } from 'redux-actions';
import * as filtersActions from '../../actions/filters/filters';

let initialState = {
  allFilters: null,
  profileFilters: null,
  allProfileFilters: null,
};

export const filters = handleActions(
  {
    //
    [filtersActions.getAllFilters]: (state, action) => {
      return { ...state, isLoading: true };
    },
    [filtersActions.getAllFiltersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allFilters: payload,
        isLoading: false,
      };
    },
    [filtersActions.getAllFiltersFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
    [filtersActions.getProfileFilters]: (state, action) => {
      return { ...state, isLoadingProfileFilters: true };
    },
    [filtersActions.getProfileFiltersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        profileFilters: payload.profileFilters,
        allProfileFilters: payload.allProfileFilters,
        isLoadingProfileFilters: false,
      };
    },
    [filtersActions.getProfileFiltersFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoadingProfileFilters: false,
      };
    },
    [filtersActions.setProfileFilter]: (state, action) => {
      if (!state.allProfileFilters) return state;
      let { payload } = action;
      let newIds = [];
      newIds = !state.allProfileFilters.newIds
        ? [...state.allProfileFilters.ids]
        : state.allProfileFilters.newIds;
      const indexSearch = newIds.indexOf(payload.key);
      if (payload.value) {
        if (indexSearch === -1) {
          newIds.push(payload.key);
        }
      } else {
        if (indexSearch !== -1) {
          newIds.splice(indexSearch, 1);
        }
      }
      // state.allProfileFilters && state.allProfileFilters;

      return {
        ...state,
        allProfileFilters: {
          ...state.allProfileFilters,
          update: true,
          newIds,
        },
      };
    },
    [filtersActions.resetProfileFilters]: (state, action) => {
      return {
        ...state,
        allProfileFilters: {
          ...state.allProfileFilters,
          update: false,
          newIds: [
            ...(state.allProfileFilters ? state.allProfileFilters.ids : []),
          ], // fix bag
        },
      };
    },
    [filtersActions.clearProfileFilters]: (state, action) => {
      return {
        ...state,
        profileFilters: null,
        allProfileFilters: null,
      };
    },
    [filtersActions.updateProfileFilters]: (state, action) => {
      return { ...state, isLoadingUpdateProfileFilters: true };
    },
    [filtersActions.updateProfileFiltersSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        profileFilters: payload.profileFilters,
        allProfileFilters: payload.allProfileFilters,
        isLoadingUpdateProfileFilters: false,
      };
    },
    [filtersActions.updateProfileFiltersFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoadingUpdateProfileFilters: false,
      };
    },
  },
  initialState
);
